var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"account-button",attrs:{"slot":"activator","type":"button"},slot:"activator"},[_c('img',{attrs:{"src":require("../../../assets/icons/user.png"),"alt":"User Icon"}}),_vm._v(" "+_vm._s(_vm.currentUserFullName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }